import React, { useEffect, useState } from 'react';
import { InputNumber, Form, Input, Select } from 'antd';
import { GET, errorCatch } from 'fennec-ui'
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import ObjectSelectOption from '../../../fedance-ui/ObjectSelectOption';
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

const { Option } = Select;

function SelectGroup({ value, onChange, options }) {
    return (
        <Input.Group compact style={{ display: "flex" }}>
            <Select
                onChange={onChange}
                value={value}

                style={{ flex: "auto" }}
                allowClear
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                    option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                filterSort={(optionA, optionB) =>
                    optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())
                }
            >
                {options}
            </Select>
            {/* <Button style={{ padding: "4px 8px" }} onClick={() => { }}>
                <EllipsisOutlined style={{ paddingTop: "7px", fontSize: '16px' }} />
            </Button> */}
            {/* <Button style={{ padding: "4px 8px" }} onClick={()=>{}}>
                        <PlusOutlined style={{ paddingTop: "3px", fontSize: '16px' }} />
                    </Button> */}
        </Input.Group>
    );
}

export default function NovieUslugiKlientu(props) {
    const { auth, object, form, sourceKey, soruceID, orgID } = props;
    const [data, setData] = useState([]);
    useEffect(() => {
        form.resetFields();
        let organizatorKey = ""
        if (sourceKey == "reg") {
            organizatorKey = "&w-organizatorRegionalnoeOtdelenie=" + orgID
        } else if (sourceKey == "school") {
            organizatorKey = "&w-organizatorShkola=" + orgID
        } else if (sourceKey == "org") {
            organizatorKey = "&w-organizatorMeropriyatiya=" + orgID
        }

        let postfix = "";
        if (sourceKey === "admin") {
            postfix = `/${soruceID}`
        }

        GET(auth, "/api/yacheikiuslugi/list/" + sourceKey + postfix + "?detail=model&w-notActive=false&" + (soruceID ? `w-eqornu-meropriyatie.ID=${soruceID}&` : "") + organizatorKey,
            ({ data }) => {
                setData(data);
            },
            (err) => errorCatch(err));
    }, []);
    // const dataOptions = data.map((i) => <Option key={i.ID} value={i.ID}>{i.nazvanie}</Option>);
    const dataOptions = ObjectSelectOption({ collection: data })
    // const dataOptions = data.map((i) => {
    //     let desc = "";
    //     if (i?.organizatorFederatsiya) {
    //         desc = "Федерация"
    //     } else if (i?.organizatorRegionalnoeOtdelenie) {
    //         desc = "" + i?.organizatorRegionalnoeOtdelenie?.nazvanie
    //     } else if (i?.organizatorShkola) {
    //         desc = "" + i?.organizatorShkola?.nazvanieShkoliTantsev
    //     } else if (i?.organizatorMeropriyatiya) {
    //         desc = "" + i?.organizatorMeropriyatiya?.nazvanie
    //     }

    //     if (i?.meropriyatie) {
    //         desc += ", " + `${i?.meropriyatie?.nazvanieMeropriyatiya} - ${dayjs(i?.meropriyatie?.nachaloSorevnovaniya).format("DD.MM.YYYY")} ${(i?.meropriyatie?.mestoProvedeniya) ? "(" + i?.meropriyatie?.mestoProvedeniya?.name + ")" : ""}`
    //     }
    //     return (<Option key={i.ID} value={i.ID} label={i.nazvanie + ((i.opisanie)?" " +i.opisanie:"")}>
    //         <div><span>{i.nazvanie}</span> {(i.opisanie) && <span style={{fontWeight:"lighter"}}>{i.opisanie}</span>}</div>
    //         {desc && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>{desc}</div>}
    //     </Option>)
    // });
    return (
        <>
            <Form
                form={form}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={{
                    ...object
                }}
            >
                <Form.Item label="Позиция"
                    name="yacheikaUslugaID"
                    rules={[{ required: true, message: 'Пожалуйста, укажите позицию!' }]}
                >
                    <SelectGroup onChange={(key, item) => {
                        // if(!form.getFieldValue("nazvanie")) {
                        //     form.setFieldsValue({"nazvanie": item.label})
                        // }
                        // if(!form.getFieldValue("opisanie")) {
                        //     form.setFieldsValue({"opisanie": item.label})
                        // }
                    }}
                        options={dataOptions}
                    />
                </Form.Item>
                {/* <Form.Item label="Название"
                    hidden={true}
                    name="nazvanie"
                    rules={[{ required: true, message: 'Пожалуйста, укажите название!' }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item label="Описание"
                    hidden={true}
                    name="opisanie"
                    rules={[{ required: false, message: 'Пожалуйста, укажите описание!' }]}
                >
                    <Input />
                </Form.Item> */}
                <Form.Item label="Количество"
                    name="kolichestvo"
                    rules={[{ required: true, message: 'Пожалуйста, укажите количество!' }]}
                >
                    <InputNumber />
                </Form.Item>
                <hr></hr>
                <div>ВЫБЕРИТЕ ОДНО ПОЛЕ ИЗ ДВУХ 👇🏼</div>
                <Form.Item label="Доля позиции в услуге, выраженная в процентах от общей стоимости услуги"
                    name="protsentObshcheiSummiUslugiNaMeropriyatii"
                    rules={[{ required: false, message: 'Пожалуйста, укажите процент!' }]}
                >
                    <InputNumber />
                </Form.Item>
                <Form.Item label="Доля позиции в услуге, выраженная в рублях"
                    name="rubleiOtObshcheiSummiUslugiNaMeropriyatii"
                    rules={[{ required: false, message: 'Пожалуйста, укажите сумму!' }]}
                >
                    <InputNumber />
                </Form.Item>
            </Form>
        </>
    );
}
